import { useCallback, useEffect, useState } from "react";
import type * as React from "react";
import { Box, Typography } from "@mui/material";
import { useHistory } from "react-router-dom";
import GradientFramedLayout from "components/v3/layouts/GradientFramedLayout";
import { standaloneSurfaceCardSx } from "components/v3/layouts/StandaloneSurveyPageLayout";
import AccountExitLink from "components/v3/sharedComponents/AccountExitLink";
import CologuardAcknowledgementForm from "components/v3/sharedComponents/forms/CologuardAcknowledgementForm";
import GettingStartedSurveyExitConfirmationModal from "components/v3/sharedComponents/modals/GettingStartedSurveyExitConfirmationModal";
import { PATHS } from "constants/pathConstants";
import { COLOGUARD_WEBSITE_URL } from "components/v3/pages/CologuardLaunchPage/constants";
import PageTitle from "utils/PageTitle";

const CologuardAcknowledgementPage: React.FC = () => {
  const history = useHistory();
  const [exitConfirmationModalOpen, setExitConfirmationModalOpen] =
    useState(false);

  PageTitle("Cologuard Provider Release");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleCancel = () => {
    history.push(PATHS.COLOGUARD_LAUNCH_PAGE);
  };

  const handleComplete = () => {
    window.open(COLOGUARD_WEBSITE_URL, "_blank", "noopener,noreferrer");
    history.push(PATHS.COLOGUARD_REDIRECT_LANDING);
  };

  const handleExitClick = useCallback(() => {
    setExitConfirmationModalOpen(true);
  }, []);

  const handleCloseExitModal = useCallback(() => {
    setExitConfirmationModalOpen(false);
  }, []);

  return (
    <GradientFramedLayout showHeader={false}>
      <Box
        sx={{
          boxSizing: "border-box",
          display: "flex",
          flex: 1,
          flexDirection: "column",
          marginX: "auto",
          maxWidth: { md: 840, xs: "100%" },
          minWidth: 0,
          pb: { md: 6, xs: 4 },
          pt: { md: 4, xs: 3 },
          px: { md: 3, xs: 2 },
          width: "100%"
        }}
      >
        <AccountExitLink
          onClick={handleExitClick}
          sx={{ alignSelf: "flex-start", mb: 2 }}
        />

        <Box
          sx={{
            ...standaloneSurfaceCardSx,
            borderRadius: "12px",
            boxSizing: "border-box",
            p: { md: 4, xs: 2.5 },
            width: "100%"
          }}
        >
          <CologuardAcknowledgementForm
            onCancel={handleCancel}
            onComplete={handleComplete}
          />
        </Box>

        <Typography
          component="p"
          sx={{ mt: 2, textAlign: "center", typography: "body_sm_dark_gray" }}
        >
          Cologuard is a registered trademark of the Abbott group of companies.
          All rights reserved.
        </Typography>
      </Box>
      <GettingStartedSurveyExitConfirmationModal
        exitTo={PATHS.COLOGUARD_LAUNCH_PAGE}
        isOpen={exitConfirmationModalOpen}
        onCloseModal={handleCloseExitModal}
      />
    </GradientFramedLayout>
  );
};

export default CologuardAcknowledgementPage;
